工序詳情
<template>
  <div v-if="show">
    <div class="project">
      <div class="plan-title flex-between">
        <p class="flex-between">
          <span>{{ $lange == "en" ? "Unit" : "单元" }}</span>
          <el-input
            size="mini"
            :placeholder="
              $lange == 'en' ? 'Please enter Unit name' : '请输入单元名称'
            "
            v-model="projectTableParams.workshopUnitName"
          ></el-input>
        </p>
        <p class="flex-between">
          <span>{{ $lange == "en" ? "Process" : "工序" }}</span>
          <el-input
            size="mini"
            :placeholder="
              $lange == 'en' ? 'Please enter' : '请输入工序名称'
            "
            v-model="projectTableParams.childProcessName"
          ></el-input>
        </p>
        <p class="flex-between">
          <span>{{ $lange == "en" ? "Status" : "状态" }}</span>
          <el-select
            size="mini"
            v-model="projectTableParams.status"
            :placeholder="$lange == 'en' ? 'Please select' : '请选择'"
          >
            <el-option
              :label="$lange == 'en' ? 'All' : '全部'"
              value=""
            ></el-option>
            <el-option
              :label="$lange == 'en' ? 'Hang in the air' : '未完成'"
              :value="0"
            ></el-option>
            <!-- <el-option
              :label="$lange == 'en' ? 'Completed' : '已完成'"
              :value="1"
            ></el-option> -->
            <el-option
              :label="$lange == 'en' ? 'Closed' : '已关闭'"
              :value="1"
            ></el-option>
          </el-select>
        </p>
        <el-button type="primary" size="mini" @click="doSearch2">{{
            $lange == "en" ? "Search" : "搜索"
          }}</el-button>
        <el-button type="primary" size="mini" @click="openAddDialog">{{
            language("workShop.新增工序")
          }}</el-button>
        <el-button type="primary" size="mini" @click="openAddBathDialog">{{
            language("workShop.批量新增")
          }}</el-button>
        <el-button type="primary" size="mini" @click="errDialogLog = true">{{
            language("workShop.错误信息记录")
          }}</el-button>
        <el-button type="primary" size="mini" @click="showProcessLibDialog = true">工序绑定</el-button>
      </div>
      <div class="table-box not-padding">
        <cc-table
          :config="projectTableConfig"
          :params="projectTableParams2"
          :refesh-params="tableRefesh"
          :load-data="workshopProjectId > 0"
        >
        </cc-table>
      </div>
    </div>
    <el-dialog
      :title="title"
      :visible.sync="addDialog"
      width="50%"
      append-to-body
      :close-on-click-modal="false"
    >
      <template v-if="addDialog">
        <el-form
          label-width="80px"
          size="mini"
          :rules="rules"
          ref="processListForm"
          :model="editObj"
        >
          <el-form-item
            :label="$lange == 'en' ? 'Unit' : '单元'"
            prop="workshopUnitId"
          >
            <el-select
              v-model="editObj.workshopUnitId"
              placeholder=""
              @change="changeWorkshopUnitId"
            >
              <el-option
                v-for="item in workshopUnitList"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            :label="$lange == 'en' ? 'Order' : '订单'"
            prop="workshopOrderId"
          >
            <el-select
              v-model="editObj.workshopOrderId"
              placeholder=""
              @change="changeWorkshopOrderId"
            >
              <el-option
                v-for="item in workshopOrderList"
                :label="item.numbering"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="language('workShop.阶段')"
            prop="workshopProcessId"
          >
            <el-select v-model="editObj.workshopProcessId" placeholder="">
              <el-option
                v-for="item in workshopProcessList"
                :label="item.content"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            :label="language('workShop.新增工序')"
            prop="workshopChildProcesses"
          >
            <div
              class="itmes"
              v-for="(itme, index) in editObj.workshopChildProcesses"
              :key="index"
            >
              <processItems
                :itme="itme"
                :refName="'itmesFrom_' + index"
                :ref="'from_' + index"
                @deleteItems="deleteItems"
                :index="index"
              ></processItems>
            </div>
            <el-button
              style="margin-top: 20px"
              type="primary"
              icon="el-icon-plus"
              size="mini"
              @click="addItems"
            >{{ language("workShop.增加新工序") }}</el-button
            >
          </el-form-item>
        </el-form>
        <div class="button_wrap">
          <el-button @click="addDialog = false" size="mini">{{
              $lange == "en" ? "Cancel" : "取消"
            }}</el-button>
          <el-button type="primary" @click="save" size="mini">{{
              $lange == "en" ? "Submit" : "提交"
            }}</el-button>
        </div>
      </template>
    </el-dialog>

    <el-dialog
      :title="title"
      :visible.sync="editDialog"
      width="50%"
      append-to-body
      :close-on-click-modal="false"
    >
      <template v-if="editDialog">
        <el-form
          label-width="80px"
          size="mini"
          :rules="rulesEditForm"
          ref="processListEditForm"
          :model="editfrom"
        >
          <el-form-item :label="$lange == 'en' ? 'Unit' : '单元'">
            <div>{{ editfrom.workshopProjectDetails.workshopUnit.name }}</div>
          </el-form-item>

          <el-form-item :label="$lange == 'en' ? 'Order' : '订单'">
            <div>
              {{
                editfrom.workshopProjectDetails.workshopProcess.workshopOrder
                  .numbering
              }}
            </div>
          </el-form-item>
          <el-form-item :label="language('workShop.阶段')">
            <div>
              {{ editfrom.workshopProjectDetails.workshopProcess.content }}
            </div>
          </el-form-item>
          <el-form-item
            :label="language('workShop.工序')"
            prop="workshopChildProcess.name"
          >
            <el-input
              placeholder=""
              v-model="editfrom.workshopChildProcess.name"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="language('workShop.上限工时')"
            prop="workshopChildProcess.limitWorkingHours"
          >
            <el-input
              type="number"
              placeholder=""
              v-model="editfrom.workshopChildProcess.limitWorkingHours"
            ></el-input>
          </el-form-item>
          <el-form-item :label="language('workShop.标准工时')">
            <div>{{ editfrom.workshopChildProcess.standardWorkingHours }}</div>
          </el-form-item>
          <el-form-item :label="language('workShop.实际工时')">
            <div>{{ editfrom.actualWorkingHours }}</div>
          </el-form-item>
        </el-form>
        <div class="button_wrap">
          <el-button @click="editDialog = false" size="mini">{{
              $lange == "en" ? "Cancel" : "取消"
            }}</el-button>
          <el-button type="primary" @click="edit" size="mini">{{
              $lange == "en" ? "Submit" : "提交"
            }}</el-button>
        </div>
      </template>
    </el-dialog>

    <el-dialog
      :title="title"
      :visible.sync="addBathDialog"
      width="50%"
      append-to-body
      :close-on-click-modal="false"
    >
      <div v-if="addBathDialog">
        <div class="file">
          <cc-uploader
            :config="uploaderConf"
            fType="file"
            v-model="filePath"
            :fFormat="[
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            ]"
            info="只能上传xlsx文件"
            tipsText="只能上传xlsx文件"
          />
          <div class="download">
            <el-button type="primary" size="mini" @click="download"
            >下載模板</el-button
            >
          </div>
        </div>

        <el-button type="primary" size="mini" @click="setBatch">確定</el-button>
      </div>
    </el-dialog>

    <updateErrLog
      :showDownload.sync="errDialogLog"
      :title="language('workShop.错误信息记录')"
    ></updateErrLog>

    <template v-if="showProcessLibDialog">
      <processLib
        @doSearch2="doSearch2"
        :showProcessLibDialog.sync="showProcessLibDialog"
        :workshopProjectId="this.workshopProjectId"
        :title="'工序绑定'"
      ></processLib>
    </template>
  </div>
</template>
<script>
import updateErrLog from "@/components/updateErrLog.vue";
import processLib from "@/components/processLib.vue";
import processItems from "./processItems";
export default {
  components: {
    updateErrLog,
    processLib,
    processItems,
  },
  props: {
    workshopProjectId: [String, Number],
  },
  data() {
    return {
      show: false,
      projectTableParams: {
        workshopProjectId: "",
        status: "",
        workshopUnitName: "",
      },
      projectTableParams2: {
        workshopProjectId: "",
        status: "",
        workshopUnitName: "",
      },
      projectTableConfig: {
        api: "admin/fsb/workshop/project/details/rel/query",
        showPager: true,
        columns: [
          {
            prop: "workshopProjectDetails.workshopUnit.name",
            lable: this.$lange == "en" ? "Unit" : "单元",
            render:row=>{
              if(row && row.workshopProjectDetails && row.workshopProjectDetails.workshopUnit){
                return row.workshopProjectDetails.workshopUnit.name
              }
              return ""
            }
          },
          {
            prop: "workshopProjectDetails.workshopProcess.workshopOrder.numbering",
            lable: this.$lange == "en" ? "Order" : "订单",
            render:row=>{
              if(row && row.workshopProjectDetails && row.workshopProjectDetails.workshopProcess&& row.workshopProjectDetails.workshopProcess.workshopOrder){
                return row.workshopProjectDetails.workshopProcess.workshopOrder.numbering
              }
              return ""
            }
          },
          {
            prop: "workshopProjectDetails.workshopProcess.content",
            lable: this.language("workShop.阶段"),
            render:row=>{
              if(row && row.workshopProjectDetails && row.workshopProjectDetails.workshopProcess){
                return row.workshopProjectDetails.workshopProcess.content
              }
              return ""
            }
          },
          {
            prop: "workshopProjectDetails.workshopProcess.type",
            lable: this.language("workShop.阶段类型"),
            render: (rows) => {
              if (rows.workshopProjectDetails && rows.workshopProjectDetails.workshopProcess) {
                if (
                  rows.workshopProjectDetails.workshopProcess.type == "FC104"
                ) {
                  return "电气类";
                } else if (
                  rows.workshopProjectDetails.workshopProcess.type == "FC101"
                ) {
                  return "机械类";
                } else if (
                  rows.workshopProjectDetails.workshopProcess.type == "FC108"
                ) {
                  return "调试类";
                }
              }
            },
          },
          {
            prop: "workshopProjectDetails.workshopProcess.id",
            lable: this.$lange == "en" ? "Process number" : "阶段编号",
            render:row=>{
              if(row && row.workshopProjectDetails && row.workshopProjectDetails.workshopProcess){
                return row.workshopProjectDetails.workshopProcess.id
              }
              return ""
            }
          },
          {
            prop: "workshopChildProcess.name",
            lable: this.$lange == "en" ? "Estimated output" : "工序",
            render:row=>{
              if(row && row.workshopChildProcess ){
                return row.workshopChildProcess.name
              }
              return ""
            }
          },
          {
            prop: "workshopChildProcess.standardWorkingHours",
            lable: this.$lange == "en" ? "Actual output" : "标准工时",
            render:row=>{
              if(row && row.workshopChildProcess ){
                return row.workshopChildProcess.standardWorkingHours
              }
              return ""
            }
          },
          {
            prop: "workshopChildProcess.limitWorkingHours",
            lable: this.$lange == "en" ? "Estimated working hours" : "上限工时",
          },
          {
            prop: "actualWorkingHours",
            lable: this.$lange == "en" ? "Actual working hours" : "实际工时",
          },

          {
            // prop: "workshopProjectDetails.workshopUnit.deptName",
            prop: "deptName",
            lable: this.$lange == "en" ? "Responsible department" : "负责部门",
          },

          {
            prop: "workshopProjectDetails.actualPersonnel",
            lable: this.$lange == "en" ? "Practical personnel" : "实际人员",
            render:row=>{
              if(row && row.workshopProjectDetails ){
                return row.workshopProjectDetails.actualPersonnel
              }
              return ""
            }
          },
          {
            prop: "workshopChildProcess.status",
            lable: this.$lange == "en" ? "Status" : "状态",
            type: "tag",
            options: [
              {
                tagType: "warning",
                text: this.$lange == "en" ? "Hang in the air" : "未完成",
              },
              // {
              //   tagType: "success",
              //   text: this.$lange == "en" ? "Completed" : "已完成",
              // },
              {
                tagType: "info",
                text: this.$lange == "en" ? "Closed" : "已关闭",
              },
            ],
          },
          // {
          //   prop: "remark",
          //   lable: this.$lange == "en" ? "Remark" : "备注",
          // },
        ],
        buttonsLabel: this.$lange == "en" ? "Operation" : "操作",
        buttons: [
          {
            name: this.$lange == "en" ? "Delete" : "删除",
            click: (row) => {
              this.$confirm("你当前操作会删除该工序, 是否确定?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }).then(() => {
                this.deleteList(row);
              });
            },
            check: (row) => {
              if (
                row.workshopChildProcess &&
                row.workshopChildProcess.status == 1
              ) {
                return false;
              }
              return true;
            },
          },
          {
            name: this.$lange == "en" ? "Edit" : "修改",
            click: (row) => {
              this.editDialog = true;
              this.title = this.language("workShop.查看修改");
              this.editfrom = JSON.parse(JSON.stringify(row));
            },
            check: (row) => {
              if (
                row.workshopChildProcess &&
                row.workshopChildProcess.status == 1
              ) {
                return false;
              }
              return true;
            },
          },
          {
            name: this.$lange == "en" ? "Close" : "关闭",
            click: (row) => {
              this.$confirm("你当前操作会关闭该工序, 是否确定?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }).then(() => {
                this.closeList(row);
              });
            },
            check: (row) => {
              if (
                row.workshopChildProcess &&
                row.workshopChildProcess.status == 0
              ) {
                return true;
              }
              return false;
            },
          },
        ],
      },
      tableRefesh: 1,
      addDialog: false,
      addBathDialog: false,
      editObj: {},
      title: "",

      workshopUnitList: [],
      workshopOrderList: [],
      workshopProcessList: [],

      rules: {
        workshopOrderId: {
          required: true,
          message: this.language("workShop.不能为空"),
          trigger: "blur",
        },
        workshopProcessId: {
          required: true,
          message: this.language("workShop.不能为空"),
          trigger: "blur",
        },
        workshopUnitId: {
          required: true,
          message: this.language("workShop.不能为空"),
          trigger: "blur",
        },
        workshopChildProcesses: {
          required: true,
          validator: this.checkWorkshopChildProcesses,
          trigger: "blur",
        },
      },

      editDialog: false,
      editfrom: "",
      rulesEditForm: {
        "workshopChildProcess.limitWorkingHours": {
          required: true,
          validator: this.checkWorkshopChildProcessLimitWorkingHours,
          trigger: "blur",
        },
        "workshopChildProcess.name": {
          required: true,
          message: this.language("workShop.不能为空"),
          trigger: "blur",
        },
      },
      uploaderConf: this.$uploadUtils.config,
      filePath: "",
      errDialogLog: false,
      showProcessLibDialog: false,
    };
  },
  methods: {
    checkWorkshopChildProcesses(rule, value, callback) {
      callback();
    },
    //编辑时校验上限工时
    checkWorkshopChildProcessLimitWorkingHours(rule, value, callback) {
      if (value === "" || value * 1 < 1) {
        callback(new Error(this.language("workShop.请输入工时大于0")));
      } else if (
        value * 1 < this.editfrom.actualWorkingHours * 1 &&
        this.editfrom.actualWorkingHours > 0
      ) {
        callback(new Error(this.language("workShop.上限工时不能小于实际工时")));
      }
      callback();
    },

    doSearch2() {
      this.projectTableParams2 = { ...this.projectTableParams };
    },
    openAddDialog() {
      this.ccRequest
        .do(
          `admin/fsb/workshop/child/process/queryByWorkShopProjectId`,
          { workshopProjectId: this.workshopProjectId },
          "GET"
        )
        .then((res) => {
          this.seleteData = res;
          this.workshopUnitList = res;
          this.addDialog = true;
          this.title = this.language("workShop.新增工序");
          this.editObj = {
            workshopOrderId: "",
            workshopProcessId: "",
            workshopUnitId: "",
            workshopChildProcesses: [
              {
                limitWorkingHours: "",
                name: "",
                standardWorkingHours: "",
              },
            ],
          };
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
        });
    },
    openAddBathDialog() {
      this.addBathDialog = true;
      this.title = this.language("workShop.批量新增工序");
      this.filePath = "";
    },

    changeWorkshopUnitId(e) {
      for (let index = 0; index < this.seleteData.length; index++) {
        if (this.editObj.workshopUnitId == this.seleteData[index].id) {
          this.workshopOrderList = this.seleteData[index].workshopOrderList;
          break;
        }
      }
      this.editObj.workshopProcessId = "";
      this.editObj.workshopOrderId = "";
    },
    changeWorkshopOrderId() {
      for (let index = 0; index < this.seleteData.length; index++) {
        if (this.editObj.workshopUnitId == this.seleteData[index].id) {
          for (
            let t = 0;
            t < this.seleteData[index].workshopOrderList.length;
            t++
          ) {
            if (
              this.seleteData[index].workshopOrderList[t].id ==
              this.editObj.workshopOrderId
            ) {
              this.workshopProcessList =
                this.seleteData[index].workshopOrderList[t].workshopProcessList;
            }
          }
        }
      }
      this.editObj.workshopProcessId = "";
    },
    addItems() {
      this.editObj.workshopChildProcesses.push({
        limitWorkingHours: "",
        name: "",
        standardWorkingHours: "",
      });
    },

    save() {
      this.$refs["processListForm"].validate((valid) => {
        if (valid) {
          let editObj = {
            workshopChildProcesses: [],
          };
          let showTips = false;
          for (
            let index = 0;
            index < this.editObj.workshopChildProcesses.length;
            index++
          ) {
            let name = "from_" + index;
            if (
              this.editObj.workshopChildProcesses[index].limitWorkingHours ==
              0 ||
              this.editObj.workshopChildProcesses[index].standardWorkingHours <0 ||
              this.editObj.workshopChildProcesses[index].name == ""
            ) {
              this.$refs[name][0].checkValidate();
              showTips = true;
              break;
            }
            // else if (
            //   this.editObj.workshopChildProcesses[index].limitWorkingHours * 1 <
            //   this.editObj.workshopChildProcesses[index].standardWorkingHours *
            //     1
            // ) {
            //   this.$refs[name][0].checkValidate();
            //   showTips = true;
            //   break;
            // }

            editObj.workshopChildProcesses.push({
              limitWorkingHours:
                this.editObj.workshopChildProcesses[index].limitWorkingHours *
                1,
              name: this.editObj.workshopChildProcesses[index].name,
              standardWorkingHours:
                this.editObj.workshopChildProcesses[index]
                  .standardWorkingHours * 1,
              workshopProcessId: this.editObj.workshopProcessId,
            });
          }
          if (showTips) {
            this.$message.error("请检查内容格式再提交");
            return false;
          }
          console.log(editObj);

          this.ccRequest
            .do(
              `admin/fsb/workshop/child/process/batchSave`,
              editObj,
              "POSTJSON"
            )
            .then((res) => {
              this.addDialog = false;
              this.tableRefesh = new Date().getTime();
              this.$message({
                message: this.language("workShop.新增成功"),
                type: "success",
              });
            })
            .catch((err) => {
              this.$message.error(err.response.data.message);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    deleteList(row) {
      this.ccRequest
        .do(
          `admin/fsb/workshop/child/process/delete`,
          { id: row.workshopChildProcess.id },
          "GET"
        )
        .then((res) => {
          this.tableRefesh = new Date().getTime();
          this.$message({
            message: this.language("workShop.删除成功"),
            type: "success",
          });
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
        });
    },
    closeList(row) {
      let data = JSON.parse(JSON.stringify(row));
      data.workshopChildProcess.status = 1;
      this.ccRequest
        .do(
          `admin/fsb/workshop/child/process/save`,
          data.workshopChildProcess,
          "POSTJSON"
        )
        .then((res) => {
          this.tableRefesh = new Date().getTime();
          this.$message({
            message: this.language("workShop.关闭成功"),
            type: "success",
          });
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
        });
    },
    edit() {
      this.$refs["processListEditForm"].validate((valid) => {
        if (valid) {
          let editObj = {
            ...this.editfrom.workshopChildProcess,
          };
          this.ccRequest
            .do(`admin/fsb/workshop/child/process/save`, editObj, "POSTJSON")
            .then((res) => {
              this.editDialog = false;
              this.tableRefesh = new Date().getTime();
              this.$message({
                message: this.language("workShop.编辑成功"),
                type: "success",
              });
            })
            .catch((err) => {
              this.$message.error(err.response.data.message);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    download() {
      let url = "/vueapp/file/车间工序导入模板.xlsx";
      window.open(url);
    },
    deleteItems(index) {
      this.editObj.workshopChildProcesses.splice(index, 1);
    },
    setBatch() {
      if (this.filePath == "") {
        this.$message.error("請上傳文件");
        return false;
      }
      this.ccRequest
        .do(
          "admin/fsb/workshop/child/process/excelDataImport",
          { url: this.filePath, fileType: "xlsx" },
          "GET"
        )
        .then((res) => {
          this.addBathDialog = false;
          this.tableRefesh = new Date().getTime();
          this.$message({
            message: this.language("workShop.上传成功"),
            type: "success",
          });
        })
        .catch((err) => {
          this.addBathDialog = false;
          this.$message.error(
            this.language("workShop.上传失败请到上传记录下载错误文件")
          );
        });
    },
  },
  mounted() {
    this.projectTableParams = {
      workshopProjectId: this.workshopProjectId,
      status: "",
      workshopUnitName: "",
    };
    this.projectTableParams2 = {
      workshopProjectId: this.workshopProjectId,
      status: "",
      workshopUnitName: "",
    };
    this.show = true;
  },
};
</script>
<style scoped>
.el-tree-node__content .el-checkbox {
  opacity: 0;
  display: none;
}
.el-tree-node__label {
  margin-left: 5px;
}
</style>
<style scoped lang="scss">
.project,
.plan {
  padding: 20px;
}

.table-box {
  margin-top: 20px;
}
.search-box {
  justify-content: flex-start;
  > * {
    margin-right: 20px;
    max-width: 160px;
  }
}
.plan-title {
  justify-content: flex-start;
  padding: 5px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e4e4e4;
  > p {
    span {
      width: 35px;
      &:first-child {
        margin-right: 10px;
      }
    }

    &:not(:last-child) {
      margin-right: 30px;
    }
  }
}
.itmes {
  background: #edf0f3;
  padding: 20px;
  margin-bottom: 10px;
}
.delete_items {
  display: flex;
  justify-content: flex-end;
}
.button_wrap {
  display: flex;
  justify-content: center;
}

.file {
  margin-bottom: 20px;
}
.download {
  margin-top: 20px;
}
</style>
